import { ROLES } from '../constants/roles';

export interface IntegrityViewer {
  role?: string;
}

/** Private run traces are visible only to the platform god role. */
export function canViewPrivateRunTraces(viewer: IntegrityViewer | null | undefined): boolean {
  return viewer?.role === ROLES.GOD;
}
